import React, { useEffect, useState } from 'react';
import { XomicsApiError } from './api';
import { hasTx, tx } from './i18n';
import { Empty, Failed, Loading, Pill } from './parts';
import { errorMessage } from './ui';
import './laboratory.css';

// A laboratory error code has its own sentence when the catalogue has one.
export function labError(error) {
  if (error instanceof XomicsApiError && error.code && hasTx(`ui.lab.error.${error.code}`)) return tx(`ui.lab.error.${error.code}`);
  return errorMessage(error);
}

export const labWhen = value => new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(value));
export const labDay = value => new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeZone: 'UTC' }).format(new Date(value));

const TUBE_TONES = { accepted: 'ok', accepted_conditional: 'ok', awaiting_acceptance: 'info', awaiting_approval: 'warn', on_hold: 'warn',
  quarantined: 'bad', new_sample_requested: 'bad' };

export function TubeState({ value }) {
  return <Pill tone={TUBE_TONES[value] || 'flat'}>{tx(`ui.lab.state.${value}`)}</Pill>;
}

export function useLabSearch(initial = '') {
  const [query, setQuery] = useState(initial);
  const [search, setSearch] = useState(initial);
  useEffect(() => {
    const timer = window.setTimeout(() => setSearch(query.trim()), 250);
    return () => window.clearTimeout(timer);
  }, [query]);
  return { query, setQuery, search };
}

export function LabResource({ resource, children }) {
  if (resource.error) return <Failed message={resource.error} onRetry={resource.refresh} />;
  if (resource.data === null) return <Loading label={tx('ui.lab.loading')} />;
  return children(resource.data);
}

export function LabFacts({ entries }) {
  return <dl className="xo-lab-facts">{entries.map(([label, value]) => (
    <div key={label}><dt>{label}</dt><dd>{value}</dd></div>
  ))}</dl>;
}

export function LabPagination({ data, loading, onOffset }) {
  if (data.total <= data.limit) return null;
  return <div className="xo-foot-split">
    <span>{tx('ui.lab.showing', { from: data.offset + 1, to: Math.min(data.offset + data.limit, data.total), total: data.total })}</span>
    <div className="xo-bar-group">
      <button type="button" className="xo-btn" disabled={loading || data.offset === 0}
        onClick={() => onOffset(Math.max(0, data.offset - data.limit))}>{tx('ui.lab.previous')}</button>
      <button type="button" className="xo-btn" disabled={loading || data.offset + data.limit >= data.total}
        onClick={() => onOffset(data.offset + data.limit)}>{tx('ui.lab.next')}</button>
    </div>
  </div>;
}

export function LabEmpty({ label = 'ui.lab.no_matches' }) {
  return <Empty title={tx(label)} />;
}
